export const photoDeletedSelector = ({ thumbnail: { photoDeleted: value = '' } }: any) => value;
